import React from 'react';
import { func, object, string } from 'prop-types';
import { TextLink } from '@chaser/components';
import NotificationCard from '../index';
import useModal from '../../../../hooks/useModal';
import CollectorModal from '../../../CollectorModal';

const Collections = ({ notification, shortCode, refetch, applyOptimisticUpdate }) => {
  const showModal = useModal();
  const { metadata } = notification;
  const { contact, invoices } = metadata;

  return (
    <NotificationCard
      notification={notification}
      shortCode={shortCode}
      refetch={refetch}
      applyOptimisticUpdate={applyOptimisticUpdate}
      title="Some invoices are long overdue"
      subtitle={
        <>
          {contact?.Name}{' '}
          <TextLink
            onClick={() => {
              showModal(<CollectorModal shortCode={shortCode} invoices={invoices} />, {
                allowInTrial: true,
                shouldBeSubscribed: true,
              });
            }}
          >
            See collection options
          </TextLink>
        </>
      }
    />
  );
};

export default Collections;

Collections.propTypes = {
  shortCode: string.isRequired,
  notification: object.isRequired,
  applyOptimisticUpdate: func.isRequired,
  refetch: func.isRequired,
};
